import { render, staticRenderFns } from "./MaterialDetection.vue?vue&type=template&id=368b2472&scoped=true&"
import script from "./MaterialDetection.vue?vue&type=script&lang=js&"
export * from "./MaterialDetection.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDetection.vue?vue&type=style&index=0&id=368b2472&scoped=true&lang=css&"
import style1 from "./MaterialDetection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b2472",
  null
  
)

export default component.exports